(function () {
  'use strict';

  // =========================================================================
  // CONFIGURACAO — altere apenas esta linha
  // =========================================================================
  var API = 'https://backend-production-1bbe.up.railway.app';
  // =========================================================================

  var SHOP    = window.Shopify && Shopify.shop ? Shopify.shop : window.location.hostname;
  var SID_KEY = '_sz_sid';
  var ATT_KEY = '_sz_att';
  var ATT_TTL = 30 * 24 * 60 * 60 * 1000; // 30 dias

  // -------------------------------------------------------------------------
  // Session ID — persiste para sempre no localStorage
  // -------------------------------------------------------------------------
  function getSid() {
    var sid = localStorage.getItem(SID_KEY);
    if (!sid) {
      sid = Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
      localStorage.setItem(SID_KEY, sid);
    }
    return sid;
  }

  // -------------------------------------------------------------------------
  // Atribuicao first-touch — salva apenas uma vez, expira em 30 dias
  // -------------------------------------------------------------------------
  function getStoredAttr() {
    try {
      var raw = localStorage.getItem(ATT_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (Date.now() > d.expires) { localStorage.removeItem(ATT_KEY); return null; }
      return d;
    } catch (e) { return null; }
  }

  function detectAttr() {
    var p      = new URLSearchParams(window.location.search);
    var source = p.get('utm_source');
    var medium = p.get('utm_medium');
    var ref    = document.referrer;

    // Auto-detecta origem pelo referrer se nao vier UTM
    if (!source) {
      var fbclid = p.get('fbclid');
      var gclid  = p.get('gclid');
      if (fbclid || /facebook\.com|instagram\.com/.test(ref)) {
        source = 'meta';   medium = 'cpc';
      } else if (gclid) {
        source = 'google'; medium = 'cpc';
      } else if (/google\.com/.test(ref)) {
        source = 'google'; medium = 'organic';
      } else if (ref && !ref.includes(window.location.hostname)) {
        source = 'referral'; medium = ref.split('/')[2] || ref;
      } else if (!ref) {
        source = 'direct'; medium = 'none';
      }
    }

    return {
      utm_source:   source,
      utm_medium:   medium,
      utm_campaign: p.get('utm_campaign'),
      utm_content:  p.get('utm_content'),
      fbclid:       p.get('fbclid'),
      gclid:        p.get('gclid'),
      landing:      window.location.pathname + window.location.search,
      ts:           new Date().toISOString(),
      expires:      Date.now() + ATT_TTL,
    };
  }

  function saveFirstTouch(attr) {
    if (!getStoredAttr()) {
      localStorage.setItem(ATT_KEY, JSON.stringify(attr));
    }
  }

  // -------------------------------------------------------------------------
  // Envia evento para o backend
  // -------------------------------------------------------------------------
  function send(payload) {
    var attr = getStoredAttr() || {};
    var data = Object.assign({
      sid:          getSid(),
      shop:         SHOP,
      url:          window.location.href,
      referrer:     document.referrer,
      utm_source:   attr.utm_source,
      utm_medium:   attr.utm_medium,
      utm_campaign: attr.utm_campaign,
      utm_content:  attr.utm_content,
      landing:      attr.landing,
      fbclid:       attr.fbclid,
      gclid:        attr.gclid,
    }, payload);

    var body = JSON.stringify(data);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(API + '/event', body);
    } else {
      fetch(API + '/event', { method: 'POST', body: body, keepalive: true })
        .catch(function () {});
    }
  }

  // -------------------------------------------------------------------------
  // Atualiza atributos do carrinho — viram note_attributes no pedido
  // -------------------------------------------------------------------------
  function syncCart() {
    var attr = getStoredAttr() || {};
    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          '_sid':          getSid(),
          '_shop':         SHOP,
          '_utm_source':   attr.utm_source   || '',
          '_utm_medium':   attr.utm_medium   || '',
          '_utm_campaign': attr.utm_campaign || '',
          '_utm_content':  attr.utm_content  || '',
          '_landing':      attr.landing      || window.location.pathname,
          '_first_seen':   attr.ts           || new Date().toISOString(),
        },
      }),
    }).catch(function () {});
  }

  // -------------------------------------------------------------------------
  // Eventos de e-commerce (chame manualmente no tema se quiser)
  // -------------------------------------------------------------------------
  function trackAddToCart(productId, variantId, price, quantity) {
    send({ event: 'add_to_cart', product_id: productId, variant_id: variantId,
           price: price, quantity: quantity });
  }

  function trackViewProduct(productId, productTitle, price) {
    send({ event: 'view_product', product_id: productId,
           product_title: productTitle, price: price });
  }

  // -------------------------------------------------------------------------
  // INIT
  // -------------------------------------------------------------------------
  var attr = detectAttr();
  saveFirstTouch(attr);
  syncCart();
  send({ event: 'pageview' });

  // API publica para o tema
  window.SanchzPixel = {
    track:          send,
    trackAddToCart: trackAddToCart,
    trackViewProduct: trackViewProduct,
  };

})();
